import { render, staticRenderFns } from "./ASorItemFluctuations.vue?vue&type=template&id=2694e364"
import script from "./ASorItemFluctuations.vue?vue&type=script&lang=js"
export * from "./ASorItemFluctuations.vue?vue&type=script&lang=js"
import style0 from "./ASorItemFluctuations.vue?vue&type=style&index=0&id=2694e364&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports